import { Component } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { environment } from '../../../../environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-about-us-hero',
  imports: [LnImageFrameComponent, TranslocoPipe],
  templateUrl: './about-us-hero.component.html',
  styleUrl: './about-us-hero.component.css',
})
export class AboutUsHeroComponent {
  protected imageUrl = environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.ABOUT_US;
}
